import { Component, OnInit } from '@angular/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { HttpEventType, HttpResponse, HttpEvent } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

export interface GtacTemplateDto {
  fileName: string;
  createdBy: string;
  timestamp: string;
  notes: string;
  isActive: boolean;
  uuid: string;
}

@Component({
  selector: 'app-gtac-template',
  templateUrl: './gtac-template.component.html',
  styleUrls: ['./gtac-template.component.scss']
})
export class GtacTemplateComponent implements OnInit {

  selectedFile: File | null = null;
  selectedFileName: string = '';
  newTemplateNotes: string = '';
  isFileSelected: boolean = false; 
  uploadProgress: number = 0;
  uploading: boolean = false;
  username: string;
  gtacTemplateDto: GtacTemplateDto[] = [];
  showloading: boolean = false;

  constructor(private apiService: ApifirstService,
              private SpinnerService: NgxSpinnerService) {}

  ngOnInit(): void {
    this.apiService.tokenObj.subscribe((data) => {
      let c: any
      c = data
      this.username = c.username
    });
    this.fetchGtacTemplate();
  }

  onFileSelected(event: any): void {
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      this.selectedFile = files[0];
      this.selectedFileName = this.selectedFile.name;
      this.isFileSelected = true; 
    } else {
      this.selectedFile = null;
      this.selectedFileName = 'No file chosen';
      this.isFileSelected = false; 
    }
  }
  onUpload(): void { 
    if (!this.selectedFile) {
      console.error('No file selected for upload.');
      return;
    }
    // Create the DTO object
    const gtacDto : GtacTemplateDto = {
      fileName: this.selectedFileName,
      createdBy: this.username, 
      timestamp: new Date().toISOString(),
      notes: this.newTemplateNotes,
      isActive: true,
      uuid: ''
    };

    this.apiService.uploadGtacTemplate(gtacDto, this.selectedFile).subscribe({
      next: (event: HttpEvent<any>) => {
        console.log('Received event type:', event.type);
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round(100 * event.loaded / (event.total || 1));
          console.log(`Upload progress: ${this.uploadProgress}%`);
        }
        else if (event instanceof HttpResponse) {
          console.log('File uploaded successfully!', event.body);
          this.fetchGtacTemplate();

          this.selectedFile = null;
          this.selectedFileName = '';
          this.newTemplateNotes = '';
          this.isFileSelected = false;
          this.uploading = false;
          this.uploadProgress = 0;
        }
        else {
          console.log('Other event received:', event);
        }
      },
      error: (err: any) => {
        console.error('Upload failed:', err);
        this.uploading = false;
        this.uploadProgress = 0;
      },
      complete: () => {
        console.log('Upload process observable completed.');
      }
    });
  }

  revertVersion(version: any): void {
    console.log('Reverting to version:', version.filename);
    const gtacDto : GtacTemplateDto = {
      fileName: version.fileName,
      createdBy: version.createdBy,
      timestamp: version.timestamp,
      notes: version.notes,
      isActive:version.isActive,
      uuid: version.uuid
    };
    this.apiService.revertTemplate(gtacDto).subscribe(
      () => {
        console.log(`Version ${version.fileName} reverted successfully.`);
        this.fetchGtacTemplate();
      },
      (error) => {
        console.error('Error reverting template:', error);
        alert("Error Reverting the Template");
      }
    )
  }

  fetchGtacTemplate(){
    this.showloading = true
    this.apiService.getGtacTemplate().subscribe(
      (data:any) => {
        this.gtacTemplateDto = data;
        this.sortTemplates();
        this.showloading = false
      },
      (err) => {
        console.error('Error fetching GTAC templates:', err);
        this.SpinnerService.hide();
      }
    )
  }

  sortTemplates() {
    this.gtacTemplateDto.sort((a, b) => {
      if (a.isActive && !b.isActive) {
        return -1;
      }
      else if (!a.isActive && b.isActive) {
        return 1; 
      }
      else {
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);
        const timeA = isNaN(dateA.getTime()) ? 0 : dateA.getTime();
        const timeB = isNaN(dateB.getTime()) ? 0 : dateB.getTime();
        return timeB - timeA;
      }
    });
  }
}